"use client";

import FullLayout from "@/components/layout/full-layout";

function MainDashboardPage() {
  return <FullLayout title="Dashboard">Welcome to KaziniHR</FullLayout>;
}
export default MainDashboardPage;
